import LoadingBadge from './LoadingBadge';

export default LoadingBadge;
